import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { b2cPolicies, tokenRequest } from './adb2cConfig';
import { msalInstance } from './msalAzure';
export async function getAccessToken() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
        msalInstance.loginRedirect(b2cPolicies.authorities.SignupSignin);
        return;
    }
    const mainFlowAccount = accounts.filter((x) => x.homeAccountId.includes('b2c_1_signupsignin'))[0];
    let request = { ...tokenRequest };
    if (mainFlowAccount) {
        request = {
            ...tokenRequest,
            account: mainFlowAccount,
        };
    }
    else {
        request = {
            ...tokenRequest,
            account: accounts[0],
        };
    }
    try {
        // MSAL handles caching the token so this wont trigger a call to B2C unless necessary.
        return (await msalInstance.acquireTokenSilent(request)).accessToken;
    }
    catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            msalInstance.acquireTokenRedirect(request);
        }
        else {
            localStorage.clear();
            msalInstance.loginRedirect(b2cPolicies.authorities.SignupSignin);
        }
    }
}
